let screenfull = null;
if (__CLIENT__) {
  screenfull = require('screenfull');
} else {
  screenfull = { toggle: () => {} };
}

export default screenfull;



// WEBPACK FOOTER //
// ./common/components/screenfull.js